import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  labelName: string;
};

export const InputLabel = ({ ...props }: Props) => {
  return <L>{props.labelName}</L>;
};

type StyledProps = {};

const L = styled.span<StyledProps>`
  font-size: 14px;
  line-height: 1;
  font-weight: bold;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
`;

export default InputLabel;
